import {
  useWSModalCustom,
  useWSSnackbar,
  WSAlert,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { IWorkLog } from "@wingspanhq/payments/dist/interfaces";
import { useMutationDeleteWorkLog } from "../../../../query/workLog/mutations/useMutationDeleteWorkLog";

type Props = {
  workLog: IWorkLog;
} & WSModalCustomProps<{
  success?: boolean;
}>;

export const ModalDeleteWorkLog: React.FC<Props> = ({
  workLog,
  ...modalProps
}) => {
  const { openSnackbar } = useWSSnackbar();
  const [deleteWorkLog, deleteMeta] = useMutationDeleteWorkLog();

  return (
    <WSModal
      title="Delete work log"
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Secondary",
            label: "No, go back",
            onClick: () => {
              modalProps.onClose({ success: false });
            }
          },
          {
            kind: "Primary",
            destructive: true,
            label: "Yes, delete work log",
            onClick: () => {
              deleteWorkLog(
                { workLogId: workLog.workLogId },
                {
                  onSuccess: () => {
                    modalProps.onClose({ success: true });
                    openSnackbar({
                      icon: { name: "check" },
                      message: "Work log deleted"
                    });
                  },
                  onError: () => {
                    openSnackbar({
                      type: "warning",
                      message: "Failed to delete work log. Please try again."
                    });
                  }
                }
              );
            },
            loading: deleteMeta.isLoading
          }
        ]
      }}
      {...modalProps}
    >
      <WSList gap="XL">
        <WSText.ParagraphSm color="gray500">
          Are you sure you want to delete this work log?
        </WSText.ParagraphSm>

        <WSAlert theme="warning" title="About deleting work logs" icon="alert">
          This action cannot be undone. The work log and all associated work
          items will be permanently deleted.
        </WSAlert>
      </WSList>
    </WSModal>
  );
};

export const useModalDeleteWorkLog = () => useWSModalCustom(ModalDeleteWorkLog);
